
















import { Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import VuePannellum from 'vue-pannellum';
import Vr360Service from '@/entities/vr-360/vr-360.service';
import { IVr360 } from '@/shared/model/vr-360.model';
import { IFileGeodetic } from '@/shared/model/file-geodetic.model';
import FileGeodeticService from '@/entities/file-geodetic/file-geodetic.service';

@Component({ components: { VuePannellum } })
export default class Vr360Viewer extends Vue {
  imgUrl = '';
  @Prop() vr360Id: number;
  @Prop() dialogMode: boolean;
  @Emit()
  close() {}

  get id() {
    return parseInt(this.$route.params.vr360Id) || this.vr360Id;
  }

  vr360: IVr360 = {};
  fileGeodetic: IFileGeodetic;

  @Prop() mobileMode: boolean;
  accessToken: string = '';

  style = {};

  mounted() {
    if (this.mobileMode) {
      this.accessToken = this.$route.query.accessToken as string;
      this.style = {
        position: 'fixed',
        height: '100%',
        width: '100%',
        top: 0,
        left: 0,
        'z-index': 9999,
      };
    }
    this.fetchVr360();
  }

  formatDate(date) {
    let s = date + '';
    date = s.substring(0, s.indexOf('T'));
    date = date.split('-');
    date = date[2] + '/' + date[1] + '/' + date[0];
    return date;
  }

  onCloseClick() {
    if (this.dialogMode) {
      this.close();
    } else {
      this.$router.go(-1);
    }
  }

  @Watch('id')
  async fetchVr360() {
    let vr360Service = new Vr360Service();
    if (this.mobileMode) {
      this.vr360 = await vr360Service.findByAccessToken(this.id, this.accessToken);
      this.imgUrl = new FileGeodeticService().downloadLinkByAccessToken(this.vr360.largeImage.id, this.accessToken);
      // console.log(this.imgUrl);
    } else {
      this.vr360 = await vr360Service.find(this.id);
      this.imgUrl = new FileGeodeticService().downloadLink(this.vr360.largeImage.id);
    }
  }
}
